import script from "./GastosList.vue?vue&type=script&setup=true&lang=js"
export * from "./GastosList.vue?vue&type=script&setup=true&lang=js"

import "./GastosList.vue?vue&type=style&index=0&id=203d3e47&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-203d3e47"]])

export default __exports__